import React from 'react';
import { CheckIcon } from 'lucide-react';
interface BenefitItemProps {
  text: string;
  className?: string;
}
export function BenefitItem({
  text,
  className = ''
}: BenefitItemProps) {
  return <div className={`flex items-start space-x-3 ${className}`} data-id="element-10">
      <div className="flex-shrink-0 mt-1 bg-wellness-light/20 p-1 rounded-full" data-id="element-11">
        <CheckIcon className="w-5 h-5 text-wellness-primary" data-id="element-12" />
      </div>
      <p className="text-wellness-dark font-medium text-lg" data-id="element-13">{text}</p>
    </div>;
}